import { render, staticRenderFns } from "./ProjectTriggersRenderer.vue?vue&type=template&id=483ebd40&scoped=true&"
import script from "./ProjectTriggersRenderer.vue?vue&type=script&lang=js&"
export * from "./ProjectTriggersRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483ebd40",
  null
  
)

export default component.exports